import secrets from '../../secrets';

export const rest = props => {
  let { path, url, credentials, skipDefaultHeaders, ...options } = props;
  options = options || {};

  // support a timeout (ms) for fetch operations; uses AbortController
  const timeout = options.timeout;
  if (timeout !== undefined) {
    delete options.timeout;
  }

  if (path && !url) {
    url = `${secrets.api.baseUri}/${path}`;
  }

  url = new URL(url);

  if (options.params) {
    const params = { ...options.params };

    Object.keys(params).forEach(key => {
      if (undefined === params[key] || null === params[key]) {
        delete params[key];
      }
    });

    url.search = new URLSearchParams(params).toString();
  }

  if (!options.method) { options.method = 'get' };

  if (!skipDefaultHeaders) {
    options.headers = {
      'Content-Type': 'application/json',
      Accept: '*/*',
      'access-token': credentials.accessToken,
      ...credentials,
      ...options.headers
    };
  }

  // If a timeout was provided, use an AbortController to cancel the fetch.
  let timeoutId;
  if (timeout && typeof AbortController !== 'undefined') {
    const controller = new AbortController();
    if (!options.signal) {
      options.signal = controller.signal;
    }
    timeoutId = setTimeout(() => controller.abort(), timeout);
    const p = fetch(url, options).then(res => {
      clearTimeout(timeoutId);
      return res;
    }).catch(err => {
      clearTimeout(timeoutId);
      throw err;
    });
    return p;
  }

  return fetch(url, options);
};
